import React from 'react';

/**
 * DESIGN RULE: 
 * This component enforces the standard modal button pattern.
 * Primary actions MUST always use .rutabaga-button-primary.
 */
const ModalFooter = ({ 
  primaryLabel, 
  onPrimary, 
  secondaryLabel, 
  onSecondary, 
  loading, 
  disabled 
}) => {
  return (
    <div className="flex gap-4 pt-4 items-center">
      <button 
        type="button" 
        onClick={onSecondary}
        className="text-gray-500 hover:text-gray-700 font-medium px-4 transition-colors"
      >
        {secondaryLabel}
      </button>
      <button 
        type="submit" 
        onClick={onPrimary}
        disabled={disabled || loading}
        className="flex-1 rutabaga-button-primary"
      >
        {loading ? 'Processing...' : primaryLabel}
      </button>
    </div>
  );
};

export default ModalFooter;